// // Bottom scroll-to-offer CTA
// // Staging working example
// (function () {
//   const cta = document.querySelector('[data-sticky-scroll-cta]');
//   if (!cta) return;

//   const btn = cta.querySelector('[data-scroll-to-offer]');
//   if (!btn) return;

//   const getTargetEl = () => {
//     const selector = btn.getAttribute('data-offer-target') || '';
//     if (!selector) return null;
//     try {
//       return document.querySelector(selector);
//     } catch (e) {
//       return null;
//     }
//   };

//   const getOffset = () => {
//     const n = Number(btn.getAttribute('data-scroll-offset') || 0);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const scrollToTarget = () => {
//     const target = getTargetEl();
//     if (!target) return;

//     const offset = getOffset();
//     const top = window.pageYOffset + target.getBoundingClientRect().top - offset;

//     window.scrollTo({ top, behavior: 'smooth' });
//   };

//   btn.addEventListener('click', scrollToTarget);
// })();

// Bottom scroll-to-offer CTA
// Keeps click-to-scroll behavior + hides CTA when target covers >= 30% of viewport
(function () {
  const cta = document.querySelector('[data-sticky-scroll-cta]');
  if (!cta) return;

  const btn = cta.querySelector('[data-scroll-to-offer]');
  if (!btn) return;

  const lpLink = document.querySelector('.sticky-scroll-cta__btn[data-acq-lp-link]');

  const getTargetEl = () => {
    const selector = btn.getAttribute('data-offer-target') || '';
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (e) {
      return null;
    }
  };

  const getOffset = () => {
    const n = Number(btn.getAttribute('data-scroll-offset') || 0);
    return Number.isFinite(n) ? n : 0;
  };

  const scrollToTarget = () => {
    const target = getTargetEl();
    if (!target) return;

    const offset = getOffset();
    const top = window.pageYOffset + target.getBoundingClientRect().top - offset;

    window.scrollTo({ top, behavior: 'smooth' });
  };

  // Keep your original working click behavior
  btn.addEventListener('click', scrollToTarget);

  /* -----------------------------------------
     Visibility behavior (viewport coverage)
     Hide when target covers >= 30% of viewport
     Show when target covers < 30% of viewport
  ------------------------------------------ */

  const setHidden = (hidden) => {
    cta.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    // Hide menu link
    if (lpLink) lpLink.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  };

  const getViewportCoverageRatio = () => {
    const target = getTargetEl();
    if (!target) return 0;

    const r = target.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const visibleTop = Math.max(r.top, 0);
    const visibleBottom = Math.min(r.bottom, vh);
    const visiblePx = Math.max(0, visibleBottom - visibleTop);

    return visiblePx / Math.max(1, vh);
  };

  const updateVisibility = () => {
    const ratio = getViewportCoverageRatio();
    setHidden(ratio >= 0.3);
  };

  // Use IntersectionObserver only as a cheap "something changed" trigger
  const target = getTargetEl();
  if (target && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(updateVisibility, {
      root: null,
      threshold: [0, 0.01, 1],
    });
    io.observe(target);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);
  updateVisibility();
})();
